module.exports = __webpack_public_path__ + "img/san-jose-resort-3.79e1e88a.jpg";